import { BrowserRouter, Route, Routes } from "react-router-dom";

import Layout from "./pages/Layout/Layout";
import { SubscriptionProvider } from "./context/SubscriptionContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "./context/ThemeContext";
import useWindowDimensions from "./hooks/getWindowDimensions";
import Users from "./pages/Users/Users";
import Financial from "./pages/Financial/Financial";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Risk from "./pages/Risk/Risk";
import Pool from "./pages/Pool/Pool";
import PastRequests from "./pages/Financial/PastRequests/PastRequests";
import Login from "./pages/Login/Login";
import ClientProtectedRoute from "./ProtectedRoute";
import ProtectedRoute from "./ProtectedRoute";
import Referrals from "./pages/Referrals/Referrals";

function App() {
  const { height, width } = useWindowDimensions();

  return (
    <>
      <ToastContainer />

      <div>
        <BrowserRouter>
          <ThemeProvider>
            <SubscriptionProvider>
              <AuthProvider>
                <Routes>
                  {/* Protected routes for Client Portal */}
                 
                    <Route path="/" element={ <ProtectedRoute><Layout /></ProtectedRoute>}>
                      <Route
                        path="/users"
                        element={<Users />}
                        // element={
                        //   <AdminPermissionRoute
                        //     requiredPermission="users"
                        //     component={Users}
                        //   />
                        // }
                      />
                      <Route path="/financial" element={<Financial />} />
                      <Route
                        path="/financial/past-requests"
                        element={<PastRequests />}
                      />
                     
                      <Route path="/risk" element={<Risk />} />
                      <Route path="/pool" element={<Pool />} />
                      <Route
                      path="/referrals"
                      element={<Referrals />}
                    />
                      {/* <Route path="/profile" element={<Profile />} /> */}
                    </Route>
                  <Route path="/login" element={<Login />} />
                  {/* <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/unauthorized" element={<Unauthorized />} /> */}
                </Routes>
              </AuthProvider>
            </SubscriptionProvider>
          </ThemeProvider>
        </BrowserRouter>
      </div>
    </>
  );
}

export default App;
